import { SVGProps } from 'react'

export const PTIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_16816_21529)">
      <path
        d="M-0.000732422 24.0014C-0.000732422 34.3204 6.51227 43.1175 15.6513 46.5085L17.7384 24.0013L15.6513 1.49414C6.51227 4.88527 -0.000732422 13.6822 -0.000732422 24.0014Z"
        fill="#6DA544"
      />
      <path
        d="M48.0003 24C48.0003 10.7452 37.2551 0 24.0003 0C21.0646 0 18.2524 0.528094 15.6523 1.49278V46.5072C18.2524 47.472 21.0646 48 24.0003 48C37.2551 48 48.0003 37.2547 48.0003 24Z"
        fill="#D80027"
      />
      <path
        d="M15.6525 32.3489C20.2628 32.3489 24.0002 28.6115 24.0002 24.0011C24.0002 19.3907 20.2628 15.6533 15.6525 15.6533C11.0421 15.6533 7.30469 19.3907 7.30469 24.0011C7.30469 28.6115 11.0421 32.3489 15.6525 32.3489Z"
        fill="#FFDA44"
      />
      <path
        d="M10.9556 19.8252V25.0426C10.9556 27.6359 13.0578 29.7382 15.6512 29.7382C18.2446 29.7382 20.3469 27.636 20.3469 25.0426V19.8252H10.9556Z"
        fill="#D80027"
      />
      <path
        d="M15.6524 26.6077C14.7893 26.6077 14.0872 25.9055 14.0872 25.0424V22.9556H17.2176V25.0425C17.2176 25.9055 16.5154 26.6077 15.6524 26.6077Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_16816_21529">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
